import React from 'react';

export function LogLevel({ type, level }) {
  const levelDesc = (function() {
    if(type) {
      return {
        'trace': 10,
        'debug': 20,
        'info': 30,
        'warn': 40,
        'error': 50,
        'errorMessage': 50,
        'warningMessage': 50,
        'successMessage': 50,
        'debugInfo': 50,
      }[type]
    } else {
      return level
    }
  }())

  const typeDesc = (function() {
    if(level) {
      return {
        [10]: 'TRACE',
        [20]: 'DEBUG',
        [30]: 'INFO',
        [40]: 'WARN',
        [50]: 'ERROR',
      }[level]
    } else {
      return type?.toUpperCase();
    }
  }())

  return <>
    {levelDesc} {typeDesc}
    </>
}

export function logColor(line) {
  if(line.type) {
    return {
      info: '#fff',
      warn: '#ffc',
      error: '#fcc',
      errorMessage: '#fcc',
      warningMessage: '#ffc',
      successMessage: '#ffc',
    }[line.type];
  } else {
    return {
      [30]: '#fff',
      [40]: '#ffc',
      [50]: '#fcc',
    }[line.level];
  }
}

export default LogLevel
